<template>
  <section class="pb-8" id="contact">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row justify="center">
            <v-col cols="12" sm="9">
              <h1 class="font-weight-light display-1">联系我们</h1>
              <h3 class="font-weight-light mt-3">
                如您需要预览测试版的自习室小程序，请添加微信。
              </h3>
              <h3 class="font-weight-light mt-3">
                您可以在我们的指导下自行购买网控设备，也可以由我们代购以保证适配易座自习室自助系统。
              </h3>
              <h3 class="font-weight-light mt-3">
                微信：dadagyzxs
              </h3>
              <h3 class="font-weight-light">
                邮箱：sublease.ak@gmail.com
              </h3>
            </v-col>

            <v-col cols="12" sm="3">
              <v-img src="http://file.sl.dande.online/static/landing/cs-wx-qr-code.jpg"
              class="qr-code-image"/>
            </v-col>

<!--            <v-col cols="12" sm="7">-->
<!--              <v-form ref="form" v-model="valid" :lazy-validation="lazy">-->
<!--                <v-text-field-->
<!--                    v-model="name"-->
<!--                    :rules="nameRules"-->
<!--                    label="Nome"-->
<!--                    required-->
<!--                ></v-text-field>-->

<!--                <v-text-field-->
<!--                    v-model="wxAccount"-->
<!--                    :rules="wxAccountRules"-->
<!--                    label="E-mail"-->
<!--                    required-->
<!--                ></v-text-field>-->

<!--                <v-textarea-->
<!--                    v-model="textArea"-->
<!--                    :rules="textAreaRules"-->
<!--                    label="Mensagem"-->
<!--                    required-->
<!--                />-->

<!--                <v-btn-->
<!--                    :disabled="!valid"-->
<!--                    color="primary"-->
<!--                    :dark="valid"-->
<!--                    rounded-->
<!--                    block-->
<!--                    class="mt-3"-->
<!--                    @click="submit"-->
<!--                >-->
<!--                  提交-->
<!--                </v-btn>-->
<!--              </v-form>-->
<!--            </v-col>-->
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <div class="svg-border-waves text-white">
      <v-img src="~@/assets/img/borderWavesBlue.svg"/>
    </div>
    <v-snackbar
        v-model="snackbar.enabled"
        timeout="3000"
        right
        top
        :color="snackbar.color"
    >
      {{ snackbar.text }}

      <template v-slot:action="{ attrs }">
        <v-btn
            text
            v-bind="attrs"
            @click="snackbar.enabled = false"
        >
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
  </section>
</template>

<script>
// import {db} from '@/main'

export default {
  data: () => ({
    icons: ["fa-facebook", "fa-twitter", "fa-linkedin", "fa-instagram"],
    valid: true,
    name: "",
    nameRules: [
      (v) => !!v || "该字段必填",
      (v) => (v && v.length >= 1) || "请输入您的称呼",
    ],
    wxAccount: "",
    wxAccountRules: [
      (v) => !!v || "该字段必填",
      (v) => /^[a-zA-Z][a-zA-Z\d_-]{5,19}$/.test(v) || "微信号格式错误，请检查后重新输入",
    ],
    textArea: "",
    textAreaRules: [
      (v) => !!v || "该字段必填",
      (v) => (v && v.length >= 10) || "留言字段必填",
    ],
    lazy: false,
    snackbar: {
      enabled: false,
      text: '',
      color: ''
    }
  }),
  methods: {
    submit() {
      /*db.collection("contactData").add({
        name: this.name,
        email: this.email,
        message: this.textArea
      }).then(() => {
        this.snackbar.text = "Mensagem enviada com sucesso"
        this.snackbar.color = "success"
        this.snackbar.enabled = true
      }).catch(() => {
        this.snackbar.text = "Erro ao enviar mensagem"
        this.snackbar.color = "danger"
        this.snackbar.enabled = true
      })*/
    }
  }
};
</script>


<style scoped>
  #contact {
    background-color: #f4f7f5;
  }

  .svg-border-waves .v-image {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 3rem;
    width: 100%;
    overflow: hidden;
  }
  .qr-code-image {
width: 100%;
  }
</style>